// FEATURES TYPES
const TYPE_CONTRACT = 'CONTRACT';
const TYPE_GENAI = 'GENAI';
const TYPE_MASS_BALANCE = 'MASSBALANCE';
const TYPE_EVENT_MANAGEMENT = 'EVENT_MANAGEMENT';
const TYPE_GLOBAL_DASHBOARD = 'GLOBAL_DASHBOARD';
const FEATURES_TYPES = [
    TYPE_CONTRACT,
    TYPE_GENAI,
    TYPE_MASS_BALANCE,
    TYPE_EVENT_MANAGEMENT,
    TYPE_GLOBAL_DASHBOARD,
];

// FEATURES KEY
const MS_DYNAMICS_AX = 'ms_dynamics_ax';
const AQUASSIST = 'aquassist';
module.exports = {
    FEATURES_TYPES,
    TYPE_CONTRACT,
    TYPE_GENAI,
    MS_DYNAMICS_AX,
    AQUASSIST,
    TYPE_MASS_BALANCE,
    TYPE_EVENT_MANAGEMENT,
    TYPE_GLOBAL_DASHBOARD,
};
